import React from 'react';
import { Link } from 'react-router-dom';
import './ContactUs.css';

const ContactUs = () => {
  return (
    <div className="contact-us">
      <header className="header">
        <div className="container">
          <div className="header-left">
            <Link to="/" className="logo">
              <img src="/assets/ic_kidstrail.png" alt="KidsTrail" className="logo-icon" />
              KidsTrail
            </Link>
          </div>
          <div className="header-center">
            <div className="header-download-buttons">
              <a
                href="https://apps.apple.com/app/id6749541872"
                className="header-download-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/ic_applestore.png" alt="Download on App Store" className="header-store-icon" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.kidstrail.app"
                className="header-download-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/ic_playstore.png" alt="Get it on Google Play" className="header-store-icon" />
              </a>
            </div>
            <div className="header-social-buttons">
              <a
                href="https://www.youtube.com/@KidsTrailCare"
                className="header-social-btn"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <img src="/assets/ic_youtube.png" alt="YouTube" className="header-social-icon" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61585649347570"
                className="header-social-btn"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <img src="/assets/ic_facebook.png" alt="Facebook" className="header-social-icon" />
              </a>
              <a
                href="https://www.instagram.com/kidstrail.care/"
                className="header-social-btn"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <img src="/assets/ic_instagram.png" alt="Instagram" className="header-social-icon" />
              </a>
            </div>
          </div>
        </div>
      </header>

      <main className="main">
        <div className="container">
          <div className="contact-content">
            <h1>Contact Us</h1>
            <p className="contact-intro">
              We're here to help! If you have any questions, concerns, or feedback about KidsTrail, 
              please don't hesitate to reach out to us.
            </p>

            <section className="contact-section">
              <h2>📧 Email Support</h2>
              <div className="contact-info">
                <div className="contact-item">
                  <h3>General Inquiries & Support</h3>
                  <p>Email: <a href="mailto:care@kidstrail.net" className="email-link">care@kidstrail.net</a></p>
                </div>
                
                <div className="contact-item">
                  <h3>Content Issues & Reports</h3>
                  <p>Email: <a href="mailto:care@kidstrail.net" className="email-link">care@kidstrail.net</a></p>
                  <p className="note">Please include "Content Issue" in your subject line</p>
                </div>
                
                <div className="contact-item">
                  <h3>Privacy Policy Questions</h3>
                  <p>Email: <a href="mailto:care@kidstrail.net" className="email-link">care@kidstrail.net</a></p>
                  <p className="note">Subject: Privacy Policy Inquiry</p>
                </div>
              </div>
            </section>

            <section className="contact-section">
              <h2>📱 App Support</h2>
              <div className="support-info">
                <div className="support-item">
                  <h3>Technical Issues</h3>
                  <p>If you're experiencing technical problems with the KidsTrail app, please email us with:</p>
                  <ul>
                    <li>Device model and operating system version</li>
                    <li>App version</li>
                    <li>Description of the issue</li>
                    <li>Steps to reproduce the problem</li>
                  </ul>
                </div>
                
                <div className="support-item">
                  <h3>Feature Requests</h3>
                  <p>We love hearing your ideas! Send us your suggestions for new features or improvements.</p>
                </div>
                
                <div className="support-item">
                  <h3>Account & Subscription Support</h3>
                  <p>For questions about your account, premium subscriptions, or billing issues, contact us with your account details.</p>
                </div>
              </div>
            </section>

            <section className="contact-section">
              <h2>⚠️ Content Concerns</h2>
              <div className="content-concerns">
                <p>
                  If you find any content in the app that you believe is inappropriate for children, 
                  please contact us immediately. We take content safety very seriously and will 
                  review all reports promptly.
                </p>
                <div className="urgent-contact">
                  <p><strong>Urgent Content Issues:</strong></p>
                  <p>Email: <a href="mailto:care@kidstrail.net" className="email-link">care@kidstrail.net</a></p>
                  <p>Subject: URGENT - Content Issue</p>
                </div>
              </div>
            </section>

            <section className="contact-section">
              <h2>🕐 Response Time</h2>
              <div className="response-info">
                <p>
                  We generally respond quickly within 1-7 days based on the urgency of your inquiry. 
                  We prioritize urgent matters and aim to address all concerns as promptly as possible.
                </p>
              </div>
            </section>

            <section className="contact-section">
              <h2>🌟 About KidsTrail</h2>
              <div className="about-info">
                <p>
                  KidsTrail is committed to providing a safe, educational, and fun learning environment 
                  for children. Our ad-free app focuses on interactive learning through books, drawing, 
                  and creative games, all while maintaining the highest standards of privacy and safety.
                </p>
                <div className="app-links">
                  <p><strong>Download KidsTrail:</strong></p>
                  <div className="download-links">
                    <a href="https://apps.apple.com/app/id6749541872" target="_blank" rel="noopener noreferrer" className="store-link">
                      📱 App Store
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.kidstrail.app" target="_blank" rel="noopener noreferrer" className="store-link">
                      🤖 Google Play
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2026 KidsTrail. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/" className="footer-link">Home</Link>
            <Link to="/terms-of-use" className="footer-link">Terms of Use</Link>
            <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactUs;
